import { IObservable, Subject } from '~/rage/utils';
import { IClientConfigs } from '~/shared';
import { IAdsService } from './adsServiceTypes';

interface TransformedAdItem {
	id: string;
	author: string;
	time: number;
	text: string;
	isOwner: boolean;
	phoneNumber: string;
	callsAvailable: boolean;
	status: 'pending' | 'published';
}

const stubSettings: IClientConfigs['phone']['ads'] = {
	queueMaxSizePerPlayer: 3,
	urgentQueueMaxSizePerPlayer: 5,
	feedMaxSize: 50,
	fastQueuePrice: 5000,
	slowQueuePrice: 10000,
	maxTextLength: 300,
};

const makeStubFeedItems = (): TransformedAdItem[] => [
	{
		id: '1',
		author: 'Artem Bakhia',
		time: Date.now() - 1000 * 60 * 60 * 24,
		text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
		isOwner: false,
		phoneNumber: '1234567890',
		callsAvailable: true,
		status: 'published',
	},
	{
		id: '2',
		author: 'Jevico',
		time: Date.now() - 1000 * 60 * 60 * 24 * 2,
		text: 'Hello, world!',
		isOwner: false,
		phoneNumber: '1234567890',
		callsAvailable: true,
		status: 'published',
	},
	{
		id: '3',
		author: 'Someone',
		time: Date.now() - 1000 * 60 * 60 * 24 * 3,
		text: 'Another ad',
		isOwner: false,
		phoneNumber: '1234567890',
		callsAvailable: false,
		status: 'published',
	},
];

const makeStubMyItems = (): TransformedAdItem[] => [
	{
		id: '4',
		author: 'Вы',
		time: Date.now() - 1000 * 60 * 60 * 24,
		text: 'Моё объявление в очереди',
		isOwner: true,
		phoneNumber: '1234567890',
		callsAvailable: true,
		status: 'pending',
	},
	{
		id: '5',
		author: 'Вы',
		time: Date.now() - 1000 * 60 * 60 * 24 * 2,
		text: 'Второе в очереди',
		isOwner: true,
		phoneNumber: '1234567890',
		callsAvailable: true,
		status: 'pending',
	},
	{
		id: '6',
		author: 'Вы',
		time: Date.now() - 1000 * 60 * 60 * 24 * 3,
		text: 'Уже опубликовано',
		isOwner: true,
		phoneNumber: '1234567890',
		callsAvailable: true,
		status: 'published',
	},
];

export class AdsServiceStub implements IAdsService {
	private feedAds = new Subject<TransformedAdItem[]>(makeStubFeedItems());
	private myAds = new Subject<TransformedAdItem[]>(makeStubMyItems());
	private adsSettings = new Subject<IClientConfigs['phone']['ads'] | null>(
		stubSettings,
	);

	public getFeedAds(): IObservable<TransformedAdItem[]> {
		return this.feedAds;
	}

	public getMyAds(): IObservable<TransformedAdItem[]> {
		return this.myAds;
	}

	public getAdsSettings(): IObservable<IClientConfigs['phone']['ads'] | null> {
		return this.adsSettings;
	}

	public async createAd(
		text: string,
		showPhone: boolean,
		_urgent: boolean,
	): Promise<void> {
		const my = [...this.myAds.getValue()];
		my.unshift({
			id: String(Date.now()),
			author: 'Вы',
			time: Date.now(),
			text: text,
			isOwner: true,
			phoneNumber: showPhone ? '0000000000' : '',
			callsAvailable: showPhone,
			status: 'pending',
		});

		this.myAds.next(my);
	}

	public async deleteAd(id: string): Promise<void> {
		this.myAds.next(this.myAds.getValue().filter((a) => a.id !== id));
		this.feedAds.next(this.feedAds.getValue().filter((a) => a.id !== id));
	}

	public async renewAd(id: string): Promise<void> {
		const my = this.myAds
			.getValue()
			.map((a) => (a.id === id ? { ...a, time: Date.now() } : a));

		this.myAds.next(my);
	}
}
